import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class PriorityService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI4 + "/api/priority";

  newPriority(kitchenMaster: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, kitchenMaster)
  }

  getPriorityById(priorityId: number): Observable<Object> {
    return this.http.get(`${this.url}/${priorityId}`);
  }

  Priority(Page: number, size: number, sort:any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
  getAllPriorityDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  prioritySearch(query: any, Page: any, size: any, sort: any,): Observable<Object> {

    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }
  
  syncPriorityPageData() {
    return this.http.get(`${this.url}/page/sync`);
  }


  public responseCache = new Map();

  public getAllPriorityDropDownCache(): Observable<any> {

    const priorityFromCache = this.responseCache.get(`${this.url}/dropdown`);

    if (priorityFromCache) {
        return of(priorityFromCache);
    } else {
        return this.http.get<any>(`${this.url}/dropdown`).pipe(
            tap(priority => this.responseCache.set(`${this.url}/dropdown`, priority))
        );
    }

}
}
